import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import aboutus from '../../assets/aboutus.png';

const AboutAppSection = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              fontWeight: 'bold',
              letterSpacing: '0.1em',
              color: '#2c3e50',
              mb: 3,
              fontSize: { xs: '1.8rem', md: '2.5rem' },
            }}
          >
            ABOUT OUR APP
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxWidth: '600px',
              mx: 'auto',
              color: '#6c757d',
              lineHeight: 1.6,
              fontSize: '1.1rem',
              wordBreak: 'break-word',
            }}
          >
            Homestay.Digital Keys is a modern web-based platform revolutionizing how hospitality
            businesses manage guest access through secure digital keys and automation.
          </Typography>
        </Box>

        <Grid container spacing={4} alignItems="center" direction={{ xs: 'column', md: 'row' }}>
          {/* Left - Image */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flex: 1,
              minWidth: 0,
            }}
          >
            <Box sx={{ width: '100%', maxWidth: '450px' }}>
              <img
                src={aboutus}
                alt="App Mockup Placeholder"
                style={{
                  width: '100%',
                  height: 'auto',
                  borderRadius: '16px',
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Grid>

          {/* Right - Text Content */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              flex: 1,
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                width: '100%',
                maxWidth: '550px',
                pl: { md: 3 },
              }}
            >
              {[
                {
                  title: 'CREATIVE DESIGN',
                  description:
                    'Sleek, responsive UI with modern aesthetics to simplify guest interaction and brand trust.',
                },
                {
                  title: 'EASY TO USE',
                  description:
                    'Zero training needed — instant access for guests on any browser, without downloading anything.',
                },
                {
                  title: 'BEST USER EXPERIENCE',
                  description:
                    'Fast, intuitive platform enhances satisfaction with seamless digital key access and notifications.',
                },
              ].map(({ title, description }, i) => (
                <Box key={i} sx={{ mb: i !== 2 ? 4 : 0 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <CheckCircleIcon sx={{ color: '#4f46e5', fontSize: 28, mr: 2 }} />
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 'bold',
                        color: '#2c3e50',
                        fontSize: { xs: '1rem', md: '1.1rem', lg: '1.25rem' },
                      }}
                    >
                      {title}
                    </Typography>
                  </Box>

                  <Typography
                    variant="body2"
                    sx={{
                      color: '#6c757d',
                      lineHeight: 1.5,
                      fontSize: { xs: '0.95rem', md: '1rem' },
                      pl: '46px',
                    }}
                  >
                    {description}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutAppSection;
